import GenresView from './GenresView'

export default GenresView